/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const nlRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Aanvraag om school toe te voegen',
    description: 'Vul a.u.b. het formulier hieronder in. Scholen die worden ingediend worden niet gegarandeerd toegevoegd, maar alle verzoeken worden door SheerID onderzocht en in overweging genomen. ',
    noCountry: 'Vind je het land van je school niet terug? Dan kom je niet in aanmerking voor deze aanbieding',
    searchByOrgName: 'Vind je je school niet? Zoek op naam',
    completeRequest: 'Vind je je school niet terug in de lijst van in aanmerking komende scholen of in de lijst van scholen die niet in aanmerking komen? Maak je aanvraag af',
    submit: 'Indienen',
    eligibleOrgs: 'In aanmerking komende scholen. Klik op het icoon om de naam te kopiëren, en daarna terug te keren naar het verificatieformulier',
    ineligibleOrgs: 'Niet in aanmerking komende scholen. Het spijt ons, studenten van deze scholen komen niet in aanmerking voor deze aanbieding',
    none: 'Niets',
    country: 'Waar ga jij naar school?',
    changeLanguage: 'Verander de taal',
    copied: 'gekopieerde',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    emailAddress: 'E-mail',
    poweredBy: 'Verificatiedienst mogelijk gemaakt door SheerID',
    fields: {
        countryPlaceholder: 'Selecteer land',
        domainLabel: 'School website',
        domainPlaceholder: 'www.mijnschool.edu',
        orgNameLabel: 'School naam',
        orgNamePlaceholder: 'Mijn school',
    },
    step: {
        success: {
            title: 'Bedankt voor het indienen van het verzoek om jouw school toe te voegen',
            description: 'We willen u eraan herinneren dat alle verzoeken worden beoordeeld door SheerID op basis van de vereisten voor deze aanbieding. We kunnen niet garanderen dat uw school wordt toegevoegd. Dit beoordelingsproces kan tot zeven dagen in beslag nemen.',
        },
        error: {
            title: 'Er is een onverwachte fout opgetreden',
            description: 'Het spijt ons, maar we kunnen je aanvraag niet behandelen. Probeer het later a.u.b. opnieuw.',
            seeingProblem: 'Als je dit probleem blijft zien',
            contactUs: 'neem dan contact met ons op',
        },
    },
    errorId: {
        invalidCountry: 'Veld vereist',
        invalidEmail: 'Ongeldige e-mail',
        invalidFirstName: 'Ongeldige voornaam',
        invalidLastName: 'Ongeldige achternaam',
        requiredField: 'Veld vereist',
        invalidField: 'Veld is ongeldig',
        invalidUrl: 'Ongeldige URL',
        tooManyResults: 'Je zoekopdracht leverde teveel resultaten op, probeer a.u.b. je zoekopdracht te verfijnen en probeer het opnieuw',
    },
    faq: 'Veelgestelde vragen in verband met aanvraag om school toe te voegen via SheerID',
    countries: {
        AD: 'Andorra',
        AE: 'Verenigde Arabische Emiraten',
        AF: 'Afghanistan',
        AG: 'Antigua en Barbuda',
        AI: 'Anguilla',
        AL: 'Albanië',
        AM: 'Armenië',
        AN: 'Nederlandse Antillen',
        AO: 'Angola',
        AR: 'Argentinië',
        AS: 'Amerikaans Samoa',
        AT: 'Oostenrijk',
        AU: 'Australië',
        AW: 'Aruba',
        AZ: 'Azerbeidzjan',
        BA: 'Bosnië-Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'België',
        BF: 'Burkina Faso',
        BG: 'Bulgarije',
        BH: 'Bahrein',
        BI: 'Boeroendi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivia',
        BR: 'Brazilië',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet-eiland',
        BW: 'Botswana',
        BY: 'Wit-Rusland',
        BZ: 'Belize',
        CA: 'Canada',
        CD: 'Democratische Republiek van Congo',
        CF: 'Centraal Afrikaanse Republiek',
        CG: 'Congo',
        CH: 'Zwitserland',
        CI: 'Ivoorkust (Ivoorkust)',
        CK: 'Cookeilanden',
        CL: 'Chili',
        CM: 'Kameroen',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Kaapverdië',
        CY: 'Cyprus',
        CZ: 'Tsjechië',
        DE: 'Duitsland',
        DJ: 'Djibouti',
        DK: 'Denemarken',
        DM: 'Dominica',
        DO: 'Dominicaanse Republiek',
        DZ: 'Algerije',
        EC: 'Ecuador',
        EE: 'Estland',
        EG: 'Egypte',
        EH: 'Westelijke Sahara',
        ER: 'Eritrea',
        ES: 'Spanje',
        ET: 'Ethiopië',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falkland Eilanden',
        FM: 'Micronesië',
        FO: 'Faeröer',
        FR: 'Frankrijk',
        GA: 'Gabon',
        GB: 'Verenigd Koninkrijk',
        GD: 'Grenada',
        GE: 'Georgië',
        GF: 'Frans Guyana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Groenland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (Frans)',
        GQ: 'Equatoriaal-Guinea',
        GR: 'Griekenland',
        GS: 'Zuid-Georgië en Zuidelijke Sandwicheilanden',
        GT: 'Guatemala',
        GU: 'Guam (VS)',
        GW: 'Guinee-Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard- en McDonaldeilanden',
        HN: 'Honduras',
        HR: 'Kroatië',
        HT: 'Haïti',
        HU: 'Hongarije',
        ID: 'Indonesië',
        IE: 'Ierland',
        IL: 'Israël',
        IN: 'Indië',
        IO: 'Brits-Indisch oceaan gebied',
        IQ: 'Irak',
        IR: 'Ik rende',
        IS: 'IJsland',
        IT: 'Italië',
        JM: 'Jamaica',
        JO: 'Jordanië',
        JP: 'Japan',
        KE: 'Kenia',
        KG: 'Kirgizië',
        KH: 'Cambodja',
        KI: 'Kiribati',
        KM: 'Comoren',
        KN: 'Saint Kitts & Nevis Anguilla',
        KP: 'Noord-Korea',
        KR: 'Zuid-Korea',
        KW: 'Koeweit',
        KY: 'Kaaiman Eilanden',
        KZ: 'Kazachstan',
        LA: 'Laos',
        LB: 'Libanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litouwen',
        LU: 'Luxemburg',
        LV: 'Letland',
        LY: 'Libië',
        MA: 'Marokko',
        MC: 'Monaco',
        MD: 'Moldavië',
        ME: 'Montenegro',
        MG: 'Madagascar',
        MH: 'Marshall eilanden',
        MK: 'Macedonië',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolië',
        MO: 'Macau',
        MP: 'noordelijke Mariana eilanden',
        MQ: 'Martinique (Frans)',
        MR: 'Mauritanië',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Malediven',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Maleisië',
        MZ: 'Mozambique',
        NA: 'Namibië',
        NC: 'Nieuw-Caledonië (Frans)',
        NE: 'Niger',
        NF: 'Norfolkeiland',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Nederland',
        NO: 'Noorwegen',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nieuw-Zeeland',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesië (Frans)',
        PG: 'Papoea-Nieuw-Guinea',
        PH: 'Filippijnen',
        PK: 'Pakistan',
        PL: 'Polen',
        PM: 'Saint Pierre en Miquelon',
        PN: 'Pitcairn Island',
        PR: 'Puerto Rico',
        PS: 'Palestina',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Reunion (Frans)',
        RO: 'Roemenië',
        RS: 'Servië',
        RU: 'Russische Federatie',
        RW: 'Rwanda',
        SA: 'Saoedi-Arabië',
        SB: 'Solomon eilanden',
        SC: 'Seychellen',
        SD: 'Soedan',
        SE: 'Zweden',
        SG: 'Singapore',
        SH: 'Sint Helena',
        SI: 'Slovenië',
        SK: 'Slowakije',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalië',
        SR: 'Suriname',
        SS: 'Zuid Soedan',
        ST: 'Saint Tome (Sao Tome) en Principe',
        SV: 'El Salvador',
        SY: 'Syrië',
        SZ: 'Swaziland',
        TC: 'Turks- en Caicoseilanden',
        TD: 'Tsjaad',
        TF: 'Franse zuidelijke gebieden',
        TG: 'Gaan',
        TH: 'Thailand',
        TJ: 'Tadzjikistan',
        TK: 'Tokelau',
        TL: 'Oost-Timor',
        TM: 'Turkmenistan',
        TN: 'Tunesië',
        TO: 'Tonga',
        TR: 'kalkoen',
        TT: 'Trinidad en Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Oekraïne',
        UG: 'Oeganda',
        UM: 'Kleine afgelegen eilanden van de VS',
        US: 'Verenigde Staten',
        UY: 'Uruguay',
        UZ: 'Oezbekistan',
        VA: 'Vaticaanstad',
        VC: 'Saint Vincent en de Grenadines',
        VE: 'Venezuela',
        VG: 'Maagdeneilanden (Brits)',
        VI: 'Maagdeneilanden (VS)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis- en Futuna-eilanden',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Jemen',
        YT: 'Mayotte',
        ZA: 'Zuid-Afrika',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    locales: {
        ar: 'Arabisch',
        bg: 'Bulgaars',
        cs: 'Tsjechisch',
        da: 'Deens',
        de: 'Duitse',
        el: 'Grieks',
        'en-GB': 'Engels (VK)',
        'en-US': 'Engels',
        'es-ES': 'Spaans (Spanje)',
        es: 'Spaans',
        fi: 'Fins',
        'fr-CA': 'Frans (Canadees)',
        fr: 'Frans',
        hr: 'Kroatisch',
        hu: 'Hongaars',
        id: 'Indonesisch',
        is: 'IJslands',
        it: 'Italiaans',
        iw: 'Hebreeuws',
        ja: 'Japans',
        ko: 'Koreaans',
        lt: 'Litouws',
        ms: 'Maleis',
        nl: 'Nederlands',
        no: 'Noors',
        pl: 'Pools',
        'pt-BR': 'Portugees (Brazilië)',
        pt: 'Portugees',
        ro: 'Roemeense',
        ru: 'Rusland',
        sk: 'Slowaaks',
        sl: 'Sloveens',
        sr: 'Servisch',
        sv: 'Zweeds',
        tr: 'Turks',
        'zh-HK': 'Chinees (Hong Kong)',
        zh: 'Chinese (traditioneel)',
    },
};
